import _WidgetBaseSP from 'more/_WidgetBaseSP';
import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './WidgetSelector.html?raw';
import "../../../moreCore/UI/Button/Button";
import DashboardWidgetSelect from './Widget/WidgetSelect';

import { DashboardTypes } from "./../DashboardTypes";

class DashboardWidgetSelector extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private widgetListContainer: HTMLDivElement;
    private selectedWidgets: Array<DashboardTypes.DashboardWidget> = [];
    private select: MdsLax<InstanceType<typeof DashboardWidgetSelect>>;

    private loadWidgetList() {
        //API Request to get available widgets

        //Fill Table with widgets


        this.StandbyStart();

        let data = {};

        this.RequestManager.callfunction(
            "Webtool_API_Dashboard__GetAvailableWidgets",
            data,
            lang.hitch(this, this._onGetWidgetListResponse),
            lang.hitch(this, this._onGetWidgetListError),
            false // sync
        );  
    }

    getSelectedWidgets(): Array<DashboardTypes.DashboardWidget> {
        return this.selectedWidgets;
    }

    private _onGetWidgetListResponse(response: Array<DashboardTypes.DashboardWidget>) {
        this._showWidgetList(response);
        this.StandbyStop();
    }

    private _onGetWidgetListError(err: more.requestErrorMessage) {
        console.log(err)
        alert("ERROR beim GetDashboardWidgetList: " + err.Message);
    }

    private _showWidgetList(widgets: Array<DashboardTypes.DashboardWidget>) {
        this.selectedWidgets = [];

        for (let data of widgets) {
            let div = this.UiModder.domConstruct.create("div", {
                "class": "widgetBox",
                "style": "",
            });

            let widgetSelect = new DashboardWidgetSelect();
            widgetSelect.on("select", lang.hitch(this, this._onSelectWidget, widgetSelect));
            widgetSelect.setData(data);
            widgetSelect.placeAt(div);
            this.UiModder.domConstruct.place(div, this.widgetListContainer);
        }
    }

    private _onSelectWidget(widgetSelect: MdsLax<InstanceType<typeof DashboardWidgetSelect>>) {

        let widgetData = widgetSelect.getData();
        let isSelected = widgetSelect.isSelected();

        if (!isSelected) {
            this.selectedWidgets = this.selectedWidgets.filter(data => data.name != widgetData.name);
        } else {
            this.selectedWidgets.push(widgetData);
        }

        this.emit("change");
    }

    //----------------------- LC -------------------------start
    postCreate(): void {
        super.postCreate.apply(this, arguments as any);
        this.loadWidgetList();
    }

    startup(): void {
        super.startup.apply(this, arguments as any);
    }
}

export default mdsWidget(DashboardWidgetSelector);
